// extracted by mini-css-extract-plugin
module.exports = {"blogs__footer":"styles_blogs__footer__7o_BK","blogs__link":"styles_blogs__link__FuDkq"};